import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_29_journal_voucher: any[] = [
  {
    "componentType": "screenGroup",
    "title": "Journal Voucher",
    "style": {},
    "childComponents": [
      {
        "componentType": "form",
        "Name": "journal_voucher",
        "TableName": "vouchers",
        "Plugins": [
          {
            "type": "api",
            "module": "all"
          }
        ],
        "DisplayName": "vouchers",
        "columnNumber": "m1 t1 w1",
        "style": {
          "padding": 10,
          "backgroundColor": "#ffffff",
          "direction": "column"
        },
        "Fields": [
          {
            "componentType": "fieldGroup",
            "Label": "Journal voucher details",
            "BindValue": "con_journal_voucher_details",
            "style": {
              "direction": "column"
            },
            "childComponents": [
              {
                "IncludeLabel": true,
                "Label": "Voucher No.",
                "PlaceHolder": "Will be auto generated...",
                "IsMandatory": false,
                "BindValue": "txt_voucher_no",
                "Json_Attribute": "voucher_no",
                "componentType": "textField",
                "showInSummary": false,
                "AutoPopulate": true,
                "IsReadOnly": true,
                "AutoPopulate_format": "JV_[******]",
                "IsVerticalView": true,
                "inputType": "text"
              },
              {
                "IncludeLabel": true,
                "Label": "Jobcard No.",
                "PlaceHolder": "",
                "IsMandatory": false,
                "BindValue": "job_card_id",
                "Json_Attribute": "job_card_id",
                "componentType": "searchableDropdown",
                "LookupName": "voucher_jobcard",
                "IsVerticalView": true,
                "showInSummary": true,
                "validation": []
              },
              {
                "IncludeLabel": true,
                "Label": "Voucher date",
                "PlaceHolder": "",
                "IsMandatory": true,
                "BindValue": "txt_voucher_date",
                "Json_Attribute": "voucher_date",
                "componentType": "dateField",
                "showInSummary": true,
                "IsVerticalView": true,
                "DefaultToday": true,
                "validation": [
                  {
                    "rule": "required",
                    "message": "Voucher date is required"
                  }
                ]
              },
              {
                "IncludeLabel": true,
                "Label": "Remarks",
                "PlaceHolder": "",
                "IsMandatory": true,
                "BindValue": "txt_remarks",
                "Json_Attribute": "narration",
                "componentType": "textField",
                "showInSummary": true,
                "IsVerticalView": true,
                "inputType": "text",
                "validation": [
                  {
                    "rule": "required",
                    "message": "Remarks is required"
                  }
                ]
              },
              {
                "IncludeLabel": true,
                "Label": "Ref No.",
                "PlaceHolder": "Ref No.",
                "IsMandatory": false,
                "BindValue": "txt_Ref_no",
                "Json_Attribute": "ref_no",
                "componentType": "textField",
                "showInSummary": true,
                "IsVerticalView": true,
                "inputType": "text"
              },
              {
                "IncludeLabel": true,
                "Label": "Voucher type",
                "PlaceHolder": "",
                "IsMandatory": false,
                "BindValue": "txt_voucher_type_",
                "Json_Attribute": "voucher_type",
                "componentType": "textField",
                "showInSummary": true,
                "Default_Value": "Journal",
                "IsReadOnly": true,
                "IsVerticalView": true,
                "inputType": "text"
              },
              {
                "IncludeLabel": true,
                "Label": "Reference date",
                "PlaceHolder": "",
                "IsMandatory": true,
                "BindValue": "txt_reference_date",
                "Json_Attribute": "ref_date",
                "componentType": "dateField",
                "showInSummary": true,
                "IsVerticalView": true,
                "DefaultToday": true,
                "validation": [
                  {
                    "rule": "required",
                    "message": "Reference date is required"
                  }
                ]
              }
            ]
          },
          {
            "componentType": "subModule",
            "name": "voucher_details",
            "label": "Voucher details",
            "tableName": "voucher_details",
            "lookupName": "purchase_order_details",
            "parentField": "txt_voucher_no",
            "BindValue": "voucher_details",
            "NotAllowEmpty": true,
            "childControls": [
              {
                "IncludeLabel": true,
                "Label": "Ledger",
                "PlaceHolder": "",
                "IsMandatory": true,
                "BindValue": "drp_ledger",
                "Json_Attribute": "ledger_id",
                "componentType": "searchableDropdown",
                "LookupName": "journal_ledgers",
                "IsVerticalView": true,
                "showInSummary": false,
                "EnableEditForControl": false,
                "validation": [
                  {
                    "rule": "required",
                    "message": "Ledger is required"
                  }
                ]
              },
              {
                "IncludeLabel": true,
                "Label": "Credit",
                "PlaceHolder": "",
                "IsMandatory": false,
                "BindValue": "txt_credit",
                "Json_Attribute": "credit",
                "componentType": "textField",
                "showInSummary": false,
                "IsReadOnly": false,
                "Default_Value": "0",
                "IsVerticalView": true,
                "inputType": "number"
              },
              {
                "IncludeLabel": true,
                "Label": "Debit",
                "PlaceHolder": "",
                "IsMandatory": false,
                "BindValue": "txt_debit",
                "Json_Attribute": "debit",
                "componentType": "textField",
                "showInSummary": false,
                "IsReadOnly": false,
                "Default_Value": "0",
                "IsVerticalView": true,
                "inputType": "number"
              },
              {
                "IncludeLabel": true,
                "Label": "Description",
                "PlaceHolder": "",
                "IsMandatory": true,
                "BindValue": "txt_remarks",
                "Json_Attribute": "remarks",
                "componentType": "textField",
                "showInSummary": true,
                "IsVerticalView": false,
                "inputType": "text",
                "validation": [
                  {
                    "rule": "required",
                    "message": "Description is required"
                  }
                ]
              },
              {
                "IncludeLabel": true,
                "Label": "Amount",
                "PlaceHolder": "",
                "IsMandatory": false,
                "BindValue": "txt_amount",
                "Json_Attribute": "",
                "componentType": "textField",
                "showInSummary": false,
                "IsReadOnly": true,
                "ExpressionV2": "[txt_debit]+[txt_credit]",
                "Default_Value": "0",
                "IsVerticalView": true,
                "inputType": "number"
              },
              {
                "IncludeLabel": true,
                "Label": "Party Name",
                "PlaceHolder": "",
                "IsMandatory": false,
                "BindValue": "txt_party_name",
                "Json_Attribute": "party_name",
                "componentType": "textField",
                "showInSummary": true,
                "IsVerticalView": true,
                "inputType": "text",
                "validation": [
                  {
                    "rule": "conditionalRequired",
                    "whenField": "drp_ledger",
                    "whenValue": "60e5b5c9c73d4f0f86c32338eefb5b01_000001_260316120924344_1",
                    "message": "Party Name is required when Ledger is VAT Input AC"
                  },
                   {
                    "rule": "conditionalRequired",
                    "whenField": "drp_ledger",
                    "whenValue": "0a32ae203a42491e804883b3aed2cb54_000001_260316120949698_2",
                    "message": "Party Name is required when Ledger is VAT Output AC"
                  }
                ]
              },
              {
                "IncludeLabel": true,
                "Label": "TRN (Tax Registration Number)",
                "PlaceHolder": "",
                "IsMandatory": false,
                "BindValue": "txt_trn",
                "Json_Attribute": "trn",
                "componentType": "textField",
                "showInSummary": true,
                "IsVerticalView": true,
                "inputType": "text",
                "validation": [
                   {
                    "rule": "conditionalRequired",
                    "whenField": "drp_ledger",
                    "whenValue": "60e5b5c9c73d4f0f86c32338eefb5b01_000001_260316120924344_1",
                    "message": "TRN (Tax Registration Number) is required when Ledger is VAT Input AC"
                  },
                   {
                    "rule": "conditionalRequired",
                    "whenField": "drp_ledger",
                    "whenValue": "0a32ae203a42491e804883b3aed2cb54_000001_260316120949698_2",
                    "message": "TRN (Tax Registration Number) is required when Ledger is VAT Output AC"
                  }
                ]
              },
              {
                "IncludeLabel": true,
                "Label": "Bill / Invoice Number",
                "PlaceHolder": "",
                "IsMandatory": false,
                "BindValue": "txt_bill_invoice_number",
                "Json_Attribute": "bill_invoice_number",
                "componentType": "textField",
                "showInSummary": true,
                "IsVerticalView": true,
                "inputType": "text",
                "validation": [
                  {
                    "rule": "conditionalRequired",
                    "whenField": "drp_ledger",
                    "whenValue": "60e5b5c9c73d4f0f86c32338eefb5b01_000001_260316120924344_1",
                    "message": "Bill / Invoice Number is required when Ledger is VAT Input AC"
                  },
                   {
                    "rule": "conditionalRequired",
                    "whenField": "drp_ledger",
                    "whenValue": "0a32ae203a42491e804883b3aed2cb54_000001_260316120949698_2",
                    "message": "Bill / Invoice Number is required when Ledger is VAT Output AC"
                  }
                ]
              }
            ],
            "FooterControls": [
              {
                "componentType": "textField",
                "BindValue": "txt_1",
                "IncludeLabel": false,
                "IsReadOnly": true,
                "style": {
                  "display": "none"
                }
              },
              {
                "IncludeLabel": false,
                "Label": "Total credit",
                "PlaceHolder": "",
                "IsMandatory": false,
                "BindValue": "txt_total_credit",
                "Json_Attribute": "total_credit",
                "componentType": "textField",
                "showInSummary": false,
                "IsReadOnly": true,
                "ExpressionV2": "[SUM:txt_credit]",
                "Default_Value": "0",
                "IsVerticalView": true,
                "inputType": "number"
              },
              {
                "IncludeLabel": false,
                "Label": "Total debit",
                "PlaceHolder": "",
                "IsMandatory": false,
                "BindValue": "txt_total_debit",
                "Json_Attribute": "total_debit",
                "componentType": "textField",
                "showInSummary": false,
                "IsReadOnly": true,
                "ExpressionV2": "[SUM:txt_debit]",
                "Default_Value": "0",
                "IsVerticalView": true,
                "inputType": "number",
                "validation": [
                  {
                    "rule": "condition",
                    "condition": "[total_debit] == [total_credit]",
                    "message": "Total debit and Total credit must be the same"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "componentType": "button",
        "name": "Submit",
        "onPressAction": "save",
        "style": {
          "backgroundColor": "#22c55e",
          "textColor": "#FFFFFF",
          "padding": 12,
          "borderRadius": 8
        }
      }
    ]
  }
];

